import React from 'react';
import { Box, ContentTemplate, HeaderTemplate, SectionHeader, Typography } from 'web-library';
import { Theme as AugmentedTheme, useTheme } from '@mui/material';

import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import Icon, { IconName } from 'web-library/stories/atom/Icon/Icon';
import UpdatePasswordForm from '../../modules/profile/components/UpdatePasswordForm';
import BreadCrumbs from '../../components/bread-crumbs/BreadCrumbs';

import {typographyTheme} from "web-library/theme/helper/tssHelper"
const useStyles = makeStyles()((theme) =>
({
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing(3),
      marginBottom: theme.spacing(5),
    },
    [theme.breakpoints.down('sm')]: {
      paddingTop: theme.spacing(2.5),
      marginBottom: theme.spacing(4),
    },
  },
  title: {
    color: theme.color.text.textHeader,
    marginBottom: theme.spacing(6),
  },
  passwordFormat: {
    color: theme.color.text.textHeader,
     ...typographyTheme(theme, 'h6'),
  },
  infoBox: {
    borderColor: theme.color.icon.iconSelected,
    borderWidth: 1,
    borderStyle: 'solid',
    display: 'flex',
    alignItem: 'flex-start',
    padding: '0.5rem 1rem',
    borderRadius: theme.spacing(1),
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  iconContainer: {
    height: '24px',
    maxWidth: '24px',
  },
  contentBox: {
    paddingLeft: theme.spacing(1),
  },
  loginForm: {
    maxWidth: theme.spacing(80),
    height: '100%',
  },
  boldText: {
    fontWeight: 700,
    color: theme.color.text.textSecondary,
  },
  breadCrumbs: {
    marginLeft: theme.spacing(-6.5),
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(9),
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(9),
    },
  },
}));
// P@ssw0rd1234

const UpdatePassword = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <>
      <HeaderTemplate>
        <Box className={classes.breadCrumbs}>
          <BreadCrumbs separator="NextIcon" rootName="Login" />
        </Box>
        <Typography variant="h1" className={classes.title}>
          {t('profile->>UpdatePassword.UpdatePassword')}
        </Typography>
      </HeaderTemplate>
      <ContentTemplate>
        <SectionHeader title={t('profile->>UpdatePassword.UpdatePassword')} />
        <Box className={classes.loginForm}>
          <Typography>{t('profile->>UpdatePassword.UpdatePasswordDes')}</Typography>
          <Box className={classes.infoBox}>
            <Icon
              size="XL"
              className={classes.iconContainer}
              color={theme.color.icon.iconSelected}
              name={IconName.info}
            />
            <Box className={classes.contentBox}>
              <Typography className={classes.passwordFormat}>
                {t('profile->>UpdatePassword.PasswordFormat')}
              </Typography>
              <Typography variant="body2">
                {t('profile->>UpdatePassword.Use')}{' '}
                <Typography display="inline" variant="body2" className={classes.boldText}>
                  {t('profile->>UpdatePassword.PasswordFormatDesTitle1')}
                </Typography>
                {` ${t('profile->>UpdatePassword.WithAtLeast')} `}
                <Typography display="inline" variant="body2" className={classes.boldText}>
                  {t('profile->>UpdatePassword.PasswordFormatDesTitle2')}
                </Typography>
                {` ${t('profile->>UpdatePassword.OfTheFollowing')}`}
              </Typography>
              <Typography variant="body2">
                {t('profile->>UpdatePassword.PasswordFormatDesValue')}
              </Typography>
            </Box>
          </Box>
          <UpdatePasswordForm />
        </Box>
      </ContentTemplate>
    </>
  );
};

export default UpdatePassword;
